'use client'
import { useState } from 'react'
import { getShareUrl } from '@/lib/share'
import styles from './style.module.scss'

type Props = {
  url?: string
  title?: string
}

export const LinkShareButton = ({ url }: Props) => {
  const [copied, setCopied] = useState(false)

  const handleCopy = () => {
    navigator.clipboard.writeText(getShareUrl(url)).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    })
  }

  return (
    <div className={styles.LinkShareButton}>
      <a
        type="button"
        title={copied ? 'コピーしました' : 'リンクをコピー'}
        onClick={handleCopy}
        aria-label={copied ? 'コピーしました' : 'リンクをコピー'}
      >
        <span>{copied ? 'コピーしました！' : 'リンクをコピー'}</span>
      </a>
    </div>
  )
}

export default LinkShareButton
